import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-language',
  imports: [],
  templateUrl: './change-language.html',
  styleUrl: './change-language.css'
})
export class ChangeLanguage implements OnInit {

  _translate = inject(TranslateService);
  private _cdr = inject(ChangeDetectorRef);

  onChangeIdioma(idioma: string) {

    this._translate.use(idioma).subscribe(() => {

      this._cdr.detectChanges();
    });
    localStorage.setItem('idioma', idioma);
  }

  ngOnInit(): void {

    const idiomaSalvo = localStorage.getItem('idioma');

    if (idiomaSalvo) {
      this._translate.use(idiomaSalvo);
      return;
    }

    switch (navigator.language) {
      case 'pt-BR':
        this._translate.use('pt');
        break;
      case 'es-ES':
        this._translate.use('es');
        break;
      default:
        this._translate.use('en');
        break;
    }

  }

}
